import { render, staticRenderFns } from "./StepFile.vue?vue&type=template&id=749023c4&scoped=true&"
import script from "./StepFile.vue?vue&type=script&lang=js&"
export * from "./StepFile.vue?vue&type=script&lang=js&"
import style0 from "./StepFile.vue?vue&type=style&index=0&id=749023c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749023c4",
  null
  
)

export default component.exports